export default "__VITE_ASSET__DODi0iGL__"